'use strict';

module.exports = {
    FLOW_NEW_CARD_NAME: 'newcard',
    FLOW_SESSION_CARD_NAME: 'sessioncard',
    FLOW_STORED_CARD_NAME: 'js-stored-card'
};
